<i18n lang="json">{
  "ru": {
    "rental_cost": "Стоимость аренды",
    "rental_purpose": "Цель аренды",
    "months": "Срок",
    "months_unit": "месяцев",
    "store_key_in_bank": "Хочу оставить ключ от ячейки на хранение в банке",
    "cell_size": "Размер ячейки",
    "small": "Маленькая",
    "medium": "Средняя",
    "large": "Большая",
    "rental_for_months": "Аренда за {months} месяцев",
    "preliminary_rental_price": "Предварительная цена аренды. Точную стоимость рассчитают в офисе банка.",
    "find_office": "Найти офис",
    "documents": "Документы",
    "small_description": "Подходит для хранения небольших предметов, документов, ключей, ювелирных украшений без футляров.",
    "medium_description": "Подходит для хранения драгоценностей в футлярах, документов формата А4, стандартного слитка драгоценного металла, монет из драгоценных металлов весом 1 кг и более.",
    "large_description": "Подходит для хранения предметов коллекционирования, сумок или портфелей с документами.",
    "daily_rent_small": "10 руб/сутки",
"daily_rent_medium": "25 руб/сутки",
"daily_rent_large": "30 руб/сутки"

  },
  "en": {
    "rental_cost": "Rental Cost",
    "rental_purpose": "Rental Purpose",
    "months": "Term",
    "months_unit": "months",
    "store_key_in_bank": "I want to leave the key in the bank for safekeeping",
    "cell_size": "Cell Size",
    "small": "Small",
    "medium": "Medium",
    "large": "Large",
    "rental_for_months": "Rental for {months} months",
    "preliminary_rental_price": "Preliminary rental price. The exact cost will be calculated at the bank office.",
    "find_office": "Find Office",
    "documents": "Documents",
    "small_description": "Suitable for storing small items, documents, keys, jewelry without cases.",
    "medium_description": "Suitable for storing jewelry in cases, A4 documents, standard gold bars, precious metal coins weighing 1 kg or more.",
    "large_description": "Suitable for storing collectibles, bags, or briefcases with documents.",
      "daily_rent_small": "10 RUB/day",
  "daily_rent_medium": "25 RUB/day",
  "daily_rent_large": "30 RUB/day"
  },
  "tr": {
    "rental_cost": "Kiralama Maliyeti",
    "rental_purpose": "Kiralama Amacı",
    "months": "Süre",
    "months_unit": "aylar",
    "store_key_in_bank": "Anahtarı bankada muhafaza etmek istiyorum",
    "cell_size": "Hücre Boyutu",
    "small": "Küçük",
    "medium": "Orta",
    "large": "Büyük",
    "rental_for_months": "{months} aylığına kiralayın",
    "preliminary_rental_price": "Ön kiralama fiyatı. Kesin maliyet banka ofisinde hesaplanacaktır.",
    "find_office": "Ofis Bul",
    "documents": "Belgeler",
    "small_description": "Küçük eşyaların, belgelerin, anahtarların, kutusuz mücevherlerin saklanması için uygundur.",
    "medium_description": "Kutularında mücevherlerin, A4 belgelerinin, standart külçe altınların, 1 kg veya daha fazla ağırlığında değerli metal paraların saklanması için uygundur.",
    "large_description": "Koleksiyon eşyalarının, belgeli çantaların veya evrak çantalarının saklanması için uygundur.",
     "daily_rent_small": "10 RUB/gün",
  "daily_rent_medium": "25 RUB/gün",
  "daily_rent_large": "30 RUB/gün"
  },
  "es": {
    "rental_cost": "Costo de Alquiler",
    "rental_purpose": "Propósito de Alquiler",
    "months": "Plazo",
    "months_unit": "meses",
    "store_key_in_bank": "Quiero dejar la llave en el banco para su custodia",
    "cell_size": "Tamaño de la Celda",
    "small": "Pequeña",
    "medium": "Mediana",
    "large": "Grande",
    "rental_for_months": "Alquiler por {months} meses",
    "preliminary_rental_price": "Precio preliminar del alquiler. El costo exacto se calculará en la oficina del banco.",
    "find_office": "Encontrar Oficina",
    "documents": "Documentos",
    "small_description": "Adecuado para almacenar objetos pequeños, documentos, llaves, joyas sin estuches.",
    "medium_description": "Adecuado para almacenar joyas en estuches, documentos A4, lingotes de oro estándar, monedas de metales preciosos que pesen 1 kg o más.",
    "large_description": "Adecuado para almacenar objetos de colección, bolsos o maletines con documentos.",
    "daily_rent_small": "10 RUB/día",
  "daily_rent_medium": "25 RUB/día",
  "daily_rent_large": "30 RUB/día"
  },
  "ar": {
    "rental_cost": "تكلفة الإيجار",
    "rental_purpose": "غرض الإيجار",
    "months": "المدة",
    "months_unit": "شهور",
    "store_key_in_bank": "أريد ترك المفتاح في البنك للحفظ",
    "cell_size": "حجم الخلية",
    "small": "صغيرة",
    "medium": "متوسطة",
    "large": "كبيرة",
    "rental_for_months": "الإيجار لمدة {months} أشهر",
    "preliminary_rental_price": "السعر المبدئي للإيجار. سيتم حساب التكلفة الدقيقة في مكتب البنك.",
    "find_office": "البحث عن مكتب",
    "documents": "الوثائق",
    "small_description": "مناسب لتخزين الأشياء الصغيرة، الوثائق، المفاتيح، المجوهرات بدون علب.",
    "medium_description": "مناسب لتخزين المجوهرات في العلب، الوثائق بحجم A4، سبائك الذهب القياسية، العملات المعدنية من المعادن الثمينة التي تزن 1 كجم أو أكثر.",
    "large_description": "مناسب لتخزين المقتنيات، الحقائب، أو المحافظ مع الوثائق.",
     "daily_rent_small": "10 روبل/يوم",
  "daily_rent_medium": "25 روبل/يوم",
  "daily_rent_large": "30 روبل/يوم"
  }
}</i18n>

<template>
  <section id="rental" class="">
    <div class="container">
      <div class="pt-5 pb-14 px-7 border-[1px] border-[#E1E1E1] rounded-2xl relative lg:block hidden">
        <p class="text-3xl">{{ t("rental_cost") }}</p>
        <div class="grid grid-cols-12 gap-5 mt-8">
          <div class="grid col-span-6 relative">
            <div class="flex justify-between px-5 bg-[#F9F9F9] border-[1px] border-[#E1E1E1] py-[14px] cursor-pointer"
              :class="isActive ? 'rounded-t-3xl' : 'rounded-3xl'" @click="toggleActive">
              <p class="text-[#6F6F6F]">
                {{ selectedPurpose || t("rental_purpose") }}
              </p>
              <a-icon-arrow :class="{ 'rotate-180': isActive }"></a-icon-arrow>
            </div>
            <div class="absolute mt-[54px] w-full z-10" v-if="isActive">
              <div v-for="purpose in purposes" :key="purpose"
                class="px-5 bg-[#F9F9F9] hover:bg-white border-[1px] border-[#E1E1E1] py-[14px] cursor-pointer"
                :class="{ 'rounded-b-3xl': isLastPurpose(purpose) }" @click="selectPurpose(purpose)">
                {{ purpose }}
              </div>
            </div>

            <div class="flex items-center justify-between mt-8">
              <p class="text-3xl">{{ t("months") }}</p>
              <span class="ml-3 text-2xl">{{ months }} {{ t("months_unit") }}</span>
            </div>
            <input type="range" @input="updateSlider" min="1" max="12" v-model="months" class="slider mt-6"
              id="monthsRange" />

            <div class="mt-8">
              <Ainput-checkbox id="storageKey" v-model="checkboxModel" :label="t('store_key_in_bank')">
              </Ainput-checkbox>
            </div>
            <div class="mt-8">
              <p class="text-2xl font-medium">{{ t("cell_size") }}</p>
              <div class="mt-5 grid grid-rows-1 gap-4 grid-cols-2">
                <div v-for="size in cellSizes" :key="size.value"
                  class="flex items-center gap-12 py-5 px-23 row-span-1 relative rounded-3xl border-[#E3E3E3] border-[1px] bg-[#F9F9F9] cursor-pointer"
                  :class="{ 'active-radio': cellSize === size.value }">
                  <input class="absolute left-5 cursor-pointer" type="radio" :id="size.value" :value="size.value"
                    v-model="cellSize" />
                  <label :for="size.value" class="cursor-pointer text-lg">{{
                    t(size.label)
                  }}</label>
                </div>
              </div>
              <div class="mt-5" v-if="currentSize">
                <div class="flex justify-between gap-28">
                  <div>
                    <p class="text-lg font-medium">
                      {{ t(currentSize.label) }}
                    </p>
                    <p>{{ currentSize.dimensions }}</p>
                  </div>
                  <p>{{ t(currentSize.description) }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="grid col-span-4 col-start-8">
            <div>
              <p class="text-xl">{{ t("rental_for_months", { months }) }}</p>
              <div class="flex gap-5 items-end">
                <p class="text-5xl mt-[10px]">{{ formatMoney(totalDepositAmount) }}₽</p>
                <p class="text-2xl ">{{ dailyRent }}</p>
              </div>
              <p class="text-[#6F6F6F] mt-[10px]">
                {{ t("preliminary_rental_price") }}
              </p>
              <div class="flex gap-5 mt-[30px]">
                <nuxt-link :to="localePath('/offices')">
                  <AButton width="medium">{{
                    t("find_office")
                  }}</AButton>
                </nuxt-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block lg:hidden px-4">
        <p class="text-xl mb-4">{{ t("rental_cost") }}</p>
        <div class="relative">
          <div class="flex justify-between px-5 bg-[#F9F9F9] border-[1px] border-[#E1E1E1] py-[14px] cursor-pointer"
            :class="isActive ? 'rounded-t-xl' : 'rounded-xl'" @click="toggleActive">
            <p class="text-[#6F6F6F]">
              {{ selectedPurpose || t("rental_purpose") }}
            </p>
            <a-icon-arrow :class="{ 'rotate-180': isActive }"></a-icon-arrow>
          </div>
          <div class="absolute w-full z-10" v-if="isActive">
            <div v-for="purpose in purposes" :key="purpose"
              class="px-5 bg-[#F9F9F9] hover:bg-white border-[1px] border-[#E1E1E1] py-[14px] cursor-pointer"
              :class="{ 'rounded-b-xl': isLastPurpose(purpose) }" @click="selectPurpose(purpose)">
              {{ purpose }}
            </div>
          </div>
          <div class="flex items-center justify-between mt-8">
            <p>{{ t("months") }}</p>
            <span class="ml-3 text-lg">{{ months }} {{ t("months_unit") }}</span>
          </div>
          <input type="range" @input="updateSlider" min="1" max="12" v-model="months" class="slider mt-6"
            id="monthsRange" />
          <div class="mt-5">
            <Ainput-checkbox id="storageKey" v-model="checkboxModel" class="text-sm" :label="t('store_key_in_bank')">
            </Ainput-checkbox>
          </div>
          <div class="mt-8">
            <p class="text-2xl font-medium">{{ t("cell_size") }}</p>
            <div class="mt-5 grid grid-rows-1 gap-[10px] grid-cols-2">
              <div v-for="size in cellSizes" :key="size.value"
                class="flex items-center h-10 py-[10px] pl-15 pr-5 relative rounded-xl bg-[#F9F9F9] cursor-pointer"
                :class="{ 'active-radio': cellSize === size.value }">
                <input class="absolute left-5 cursor-pointer bg-white" type="radio" :id="size.value" :value="size.value"
                  v-model="cellSize" />
                <label :for="size.value" class="cursor-pointer text-sm">{{
                  t(size.label)
                }}</label>
              </div>
            </div>
            <div class="mt-5" v-if="currentSize">
              <div class="flex justify-between text-sm gap-6">
                <div>
                  <p class="font-medium">{{ t(currentSize.label) }}</p>
                  <p>{{ currentSize.dimensions }}</p>
                </div>
                <p>{{ t(currentSize.description) }}</p>
              </div>
            </div>
            <div class="w-full mt-14">
              <AButton class="" width="mobile">{{ t("Расчитать") }}</AButton>
            </div>
          </div>
          <div class="mt-5">
            <p class="text-lg">{{ t("rental_for_months", { months }) }}</p>
            <div class="flex gap-5 items-end">
              <p class="text-4xl mt-[10px]">{{ formatMoney(totalDepositAmount) }}₽</p>
              <p class="text-base">{{ dailyRent }}</p>
            </div>
            <p class="text-[#6F6F6F] text-sm mt-[10px]">
              {{ t("preliminary_rental_price") }}
            </p>
            <div class="flex gap-5 mt-[30px]">
              <nuxt-link class="w-full" :to="localePath('/offices')">
                <AButton width="mobile">{{ t("find_office") }}</AButton>
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from "vue";

const rent = ref(0);
const months = ref(0);
const isActive = ref(false);
const cellSize = ref("small");
const purposes = ["Хранение", "Сделка"];
const selectedPurpose = ref("");
const { t } = useI18n({ useScope: "local" });
const cellSizes = [
  {
    value: "small",
    label: "small",
    dimensions: "72*260*390",
    description: "small_description",
  },
  {
    value: "medium",
    label: "medium",
    dimensions: "146*260*390",
    description: "medium_description",
  },
  {
    value: "large",
    label: "large",
    dimensions: "220*260*390",
    description: "large_description",
  },
];
const dailyRent = computed(() => {
  return t(`daily_rent_${cellSize.value}`);
});


const currentSize = computed(() =>
  cellSizes.find((size) => size.value === cellSize.value)
);

const totalDepositAmount = computed(() => {
  let rentValue;

  switch (cellSize.value) {
    case 'small':
      rentValue = 300;
      break;
    case 'medium':
      rentValue = 750;
      break;
    case 'large':
      rentValue = 900;
      break;
    default:
      rentValue = 0;
  }

  return Number(months.value) * rentValue;
});

function formatMoney(number) {
  return new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: 0,
  }).format(number);
}

function updateSlider(event) {
  const slider = event.target;
  const value = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
  slider.style.background = `linear-gradient(to right, #FCC900 ${value}%, #BFBFBF ${value}%)`;
}

function toggleActive() {
  isActive.value = !isActive.value;
}

function selectPurpose(purpose) {
  selectedPurpose.value = purpose;
  isActive.value = false;
}

function isLastPurpose(purpose) {
  return purpose === purposes[purposes.length - 1];
}
</script>
<style scoped>
input[type="radio"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border: 1px solid #e3e3e3;
  border-radius: 50%;
}

input[type="radio"]:checked::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #FCC900;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 3px;
  background: linear-gradient(to right, #FCC900 0%, #bfbfbf 0%);
  outline: none;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  background: #FCC900;
  cursor: pointer;
  border-radius: 50%;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: #FCC900;
  cursor: pointer;
  border-radius: 50%;
}
</style>
